import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import {  PackingMaterialPricesService } from "./packing-material-prices-service";
import { PackingMaterialPricesRequest, PackingMaterialPricesResponseModel, ProductPackStyleReq } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";

@ApiTags('packing-material-prices')
@Controller('packing-material-prices')
export class PackingMaterialPricesController{
    constructor(
        private service:PackingMaterialPricesService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ){}
    @Post('/createPackingMaterialPrices')
    async createPackingMaterialPrices(@Body() req:PackingMaterialPricesRequest):Promise<PackingMaterialPricesResponseModel>{
        try{
            return await this.service.createPackingMaterialPrices(req)
        }catch(err){
            return this.applicationExceptionhandler.returnException(PackingMaterialPricesResponseModel,err)
        }
    }
    @Post('/getAllPackingMaterialPricesInfo')
    async getAllPackingMaterialPricesInfo():Promise<PackingMaterialPricesResponseModel>{
        try{
            return await this.service.getAllPackingMaterialPricesInfo()
        }catch(err){
            return this.applicationExceptionhandler.returnException(PackingMaterialPricesResponseModel,err)
        }
    }

    @Post('/getPriceAgainstProductPackStyle')
    async getPriceAgainstProductPackStyle(@Body() req:ProductPackStyleReq):Promise<PackingMaterialPricesResponseModel>{
        try{
            return await this.service.getPriceAgainstProductPackStyle(req)
        }catch(err){
            return this.applicationExceptionhandler.returnException(PackingMaterialPricesResponseModel,err)
        }
    }
}